export default {
  "page": {
    "pageId": 1,
    "pageName": "My first campaign",
    "containerWidth": 1440,
    "sections": [
      {
        "sectionId": 0,
        "fields": [
          {
            "fieldType": "navbar",
            "fieldId": "kwhnnh",
            "properties": {
              "backgroundColor": "#fff",
              "title": "",
              "color": "#FFE082",
              "grid": {
                "columns": 12
              },
              "logo": {
                "imageSource": "https://cdn.freelogovectors.net/wp-content/uploads/2018/04/ariel_logo_freelogovectors.net_.png",
                "width": 60,
                "alternateText": "Brand Logo"
              },
              "fields": [
                {
                  "fieldId": "1pgw4o",
                  "fieldType": "anchor",
                  "properties": {
                    "text": "So geht's",
                    "url": "#",
                    "target": "_self",
                    "cssClass": "nav-link"
                  }
                },
                {
                  "fieldId": "bwenru",
                  "fieldType": "anchor",
                  "properties": {
                    "text": "T&C",
                    "url": "#",
                    "target": "_self",
                    "cssClass": "nav-link"
                  }
                },
                {
                  "fieldId": "iydy7h",
                  "fieldType": "anchor",
                  "properties": {
                    "text": "FAQ",
                    "url": "#",
                    "target": "_self",
                    "cssClass": "nav-link"
                  }
                }
              ]
            }
          }
        ]
      },
      {
        "sectionId": 1,
        "fields": [
          {
            "fieldType": "paragraph",
            "fieldId": "tw3qab",
            "properties": {
              "grid": {
                "columns": "12"
              },
              "text": "<center><p>&nbsp;</p><p>&nbsp;</p><p><h3>Lorem Ipsum Dolor</h3></p></center>",
              "properties": {
                "text": "  \n\nLorem Ipsum Dolor"
              }
            }
          }
        ]
      },
      {
        "sectionId": 2,
        "fields": [
          {
            "fieldType": "paragraph",
            "fieldId": "n9ng6e",
            "properties": {
              "grid": {
                "columns": 12
              },
              "text": "<center>Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br>Suspendisse blandit nunc quis libero dignissim, sed tempus<br>urna vehicula. Proin vehicula posuere metus vel commodo.</center>",
              "properties": {
                "text": "L"
              }
            }
          }
        ]
      },
      {
        "sectionId": 3,
        "fields": [
          {
            "fieldType": "paragraph",
            "fieldId": "llouvq",
            "properties": {
              "grid": {
                "columns": "4"
              },
              "text": "",
              "properties": {
                "text": "\n"
              }
            }
          },
          {
            "fieldType": "form-component",
            "fieldId": "inzf4w",
            "properties": {
              "fields": [
                {
                  "fieldId": "1sh5y9",
                  "fieldType": "text-input",
                  "properties": {
                    "name": "Vorname",
                    "label": "Vorname",
                    "placeholder": "",
                    "text": "",
                    "grid": {
                      "columns": "12"
                    }
                  }
                },
                {
                  "fieldId": "1sh5y9",
                  "fieldType": "text-input",
                  "properties": {
                    "name": "NachNname",
                    "label": "NachNname",
                    "placeholder": "",
                    "text": "",
                    "grid": {
                      "columns": "12"
                    }
                  }
                },
                {
                  "fieldId": "1sh5y9",
                  "fieldType": "text-input",
                  "properties": {
                    "name": "Email",
                    "label": "Email",
                    "placeholder": "",
                    "text": "",
                    "grid": {
                      "columns": "12"
                    }
                  }
                },
                {
                  "fieldId": "1sh5y9",
                  "fieldType": "text-input",
                  "properties": {
                    "name": "Adresse",
                    "label": "Adresse",
                    "placeholder": "",
                    "text": "",
                    "grid": {
                      "columns": "12"
                    }
                  }
                },
                {
                  "fieldId": "1sh5y9",
                  "fieldType": "text-input",
                  "properties": {
                    "name": "PLZ",
                    "label": "PLZ",
                    "placeholder": "",
                    "text": "",
                    "grid": {
                      "columns": "4"
                    }
                  }
                },
                {
                  "fieldId": "1sh5y9",
                  "fieldType": "text-input",
                  "properties": {
                    "name": "Ort",
                    "label": "Ort",
                    "placeholder": "",
                    "text": "",
                    "grid": {
                      "columns": "8"
                    }
                  }
                },
                {
                  "fieldId": "1sh5y9",
                  "fieldType": "text-input",
                  "properties": {
                    "name": "Strasse",
                    "label": "Strasse",
                    "placeholder": "",
                    "text": "",
                    "grid": {
                      "columns": "8"
                    }
                  }
                },
                {
                  "fieldId": "1sh5y9",
                  "fieldType": "text-input",
                  "properties": {
                    "name": "Nr",
                    "label": "Nr",
                    "placeholder": "",
                    "text": "",
                    "grid": {
                      "columns": "4"
                    }
                  }
                },
                {
                  "fieldId": "1sh5y9",
                  "fieldType": "text-input",
                  "properties": {
                    "name": "Land",
                    "label": "Land",
                    "placeholder": "",
                    "text": "",
                    "grid": {
                      "columns": "12"
                    }
                  }
                }
              ],
              "grid": {
                "columns": "4"
              }
            }
          },
          {
            "fieldType": "paragraph",
            "fieldId": "av91jz",
            "properties": {
              "grid": {
                "columns": "4"
              },
              "text": "",
              "properties": {
                "text": "\n"
              }
            }
          }
        ]
      }
    ]
  }
};